/*
 * top-tracks-rank.js — Spec 052 S4 client-side ranking progressive enhancement.
 *
 * Fetches the rolling-7-day Top-10 ranking from the app's /api/public/top-songs
 * through the Shopify App Proxy and reorders the server-rendered .song-row nodes
 * to match the ranking. Uses the same App-Proxy fetch pattern as download-access.js.
 *
 * Fallback (FR-011): on ANY error / non-200 / empty songs array the DOM is left
 * entirely untouched — the server-rendered collection order (newest-first) remains
 * the display. No empty state, no console error is emitted on expected failures.
 */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-top-tracks-rank]');
    if (!section) { return; }

    var base = (section.getAttribute('data-app-proxy-base') || '').trim();
    if (!base) { return; }

    var locale = (section.getAttribute('data-locale') || 'en').trim();
    var url = base.replace(/\/+$/, '') + '/top-songs?limit=10&window=7&locale=' + encodeURIComponent(locale);

    fetch(url, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) { return null; }
        return response.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.songs) || data.songs.length === 0) { return; }
        applyRanking(section, data.songs);
      })
      .catch(function () {
        // Swallow all errors — leave collection order untouched (FR-011).
      });
  }

  function applyRanking(section, songs) {
    var list = section.querySelector('[data-tt-list]');
    if (!list) { return; }

    // Build handle → rank map from the endpoint response.
    var rankMap = {};
    for (var i = 0; i < songs.length; i++) {
      var song = songs[i];
      if (song && typeof song.handle === 'string' && typeof song.rank === 'number') {
        rankMap[song.handle] = song.rank;
      }
    }
    if (Object.keys(rankMap).length === 0) { return; }

    // Collect all rendered rows.
    var rows = list.querySelectorAll('.song-row[data-handle]');
    if (!rows.length) { return; }

    var ranked = [];
    var unranked = [];
    for (var j = 0; j < rows.length; j++) {
      var row = rows[j];
      var handle = (row.getAttribute('data-handle') || '').trim();
      if (handle && rankMap.hasOwnProperty(handle)) {
        ranked.push({ rank: rankMap[handle], handle: handle, node: row });
      } else {
        unranked.push(row);
      }
    }

    // Sort ranked rows by rank ascending.
    ranked.sort(function (a, b) { return a.rank - b.rank; });

    // Cover ALL rendered rows (ranked sorted first, then unranked in original
    // order). The endpoint already caps the RANKED set to 10, so this stays
    // Top-10-driven; a literal cap of 10 would strand rows 11–12 above rank 1
    // when the section `limit` setting is 11–12 (range max 12). Spec 052 S4.
    var ordered = [];
    for (var k = 0; k < ranked.length && ordered.length < rows.length; k++) {
      ordered.push(ranked[k].node);
    }
    for (var m = 0; m < unranked.length && ordered.length < rows.length; m++) {
      ordered.push(unranked[m]);
    }

    // Re-append nodes in the new order (moves, no cloning).
    for (var n = 0; n < ordered.length; n++) {
      list.appendChild(ordered[n]);
    }

    // Update the visible rank labels to match the endpoint rank.
    // Ranked rows get their endpoint rank; unranked rows keep their DOM position
    // number (1-based within the final list order).
    for (var r = 0; r < ordered.length; r++) {
      var node = ordered[r];
      var idxCell = node.querySelector('.song-row__rank');
      if (!idxCell) { continue; }
      var handle2 = (node.getAttribute('data-handle') || '').trim();
      if (handle2 && rankMap.hasOwnProperty(handle2)) {
        idxCell.textContent = String(rankMap[handle2]);
      } else {
        idxCell.textContent = String(r + 1);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
